import { Button } from 'antd';
import { useEffect, useState } from 'react';
import visa from 'assets/images/visa.png';
import mastercard from 'assets/images/mastercard.png';
import { Card } from 'modules/profile/models/Cards';
import dayjs from 'dayjs';

function ProfileBillingCardItemComponent({ card }: { card: Card }) {
	return (
		<div className="d-flex justify-content-between align-items-end flex-wrap gap-2 p-3">
			<div>
				<h6 className="d-flex align-items-center gap-2">
					{card.name}
					{card.isPrimary && (
						<span className="status active" style={{ fontSize: 12 }}>
							Primary
						</span>
					)}
				</h6>

				<div className="d-flex gap-2">
					<img style={{ width: 70, height: 40 }} alt="payment-card" src={card.type === 'Visa' ? visa : mastercard} />
					<div>
						<p style={{ fontWeight: 600, margin: 0, color: '#3F4254' }}>
							{card.type} **** {card.number}
						</p>
						<p style={{ fontWeight: 600, margin: 0, color: '#888' }}>Card expires at {dayjs(card.expire).format('mm/YY')}</p>
					</div>
				</div>
			</div>
			<div className="d-flex justify-content-end gap-2 flex-grow-1">
				<Button className="danger">Delete</Button>
				<Button className="discard">Edit</Button>
			</div>
		</div>
	);
}

export default ProfileBillingCardItemComponent;
